export default "__VITE_ASSET__Dau1P3eT__"